<template>
  <nav>
    <ul>
      <li @click="setPage(currentPage - 1)" :class="{ disable: currentPage === 1 }">
        <a class="pointer">
          <i class="fas fa-angle-double-left"></i>
        </a>
      </li>

      <li v-for="n in totalPages" :key="n" @click="setPage(n)">
        <a :class="['pointer', { active: currentPage === n }]">
          {{ n }}
        </a>
      </li>

      <li @click="setPage(currentPage + 1)" :class="{ disable: currentPage === totalPages }">
        <a class="pointer">
          <i class="fas fa-angle-double-right"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { watch } from "vue";
import { useRoute } from "vue-router";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Pagination",
  props: {
    data: {
      type: Array,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
  },
  emits: ["handlePaginate"],
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return this.startIndex + this.itemsPerPage;
    },
  },
  methods: {
    setPage(idx) {
      if (idx <= 0 || idx > this.totalPages) return;
      window.scrollTo(0, 0);
      this.currentPage = idx;
      this.$emit("handlePaginate", this.data, this.startIndex, this.endIndex);
    },
  },
  mounted() {
    this.$emit("handlePaginate", this.data, this.startIndex, this.endIndex);
  },
  setup() {
    const route = useRoute();

    watch(
      () => route.query,
      () => {
        this.currentPage = 1;
      }
    );

    watch(
      () => route.params,
      () => {
        this.currentPage = 1;
      }
    );
  },
};
</script>
